{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-mathematik-prozent-zinsrechnung",
  "version": "2026.08.1",
  "title": "Mathematik 7: Prozentrechnung und Zinsrechnung (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Mathematik 7: Grundwert, Prozentwert, Prozentsatz, vermehrter/verminderter Grundwert und Zinsrechnung mit Zeitfaktoren.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T22:45:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/mathematik/wpfg1",
      "checked": "2026-08-15",
      "label": "Realschule Mathematik 7, Lernbereich Prozent- und Zinsrechnung"
    }
  ],
  "atoms": [
    {
      "id": "01K4M7P0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4M7P0000000000000000A01",
      "namespace": "mathematik-anwendung",
      "slug": "prozentrechnung-grundbegriffe-formel-dreisatz",
      "title": "Grundbegriffe der Prozentrechnung: Grundwert G, Prozentwert W und Prozentsatz p%",
      "domain": "schule/mathematik/arithmetik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q11229",
          "target_label": "Percentage",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4M7P0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie lautet die Grundformel zur Berechnung des Prozentwerts W aus Grundwert G und Prozentsatz p%?",
          "concept": "W = G · (p / 100) bzw. W = G · p%",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "W = G · (p / 100)",
              "W = G / (p · 100)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4M7P0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Definiere die drei Grundgrößen der Prozentrechnung (Grundwert G, Prozentwert W, Prozentsatz p = p/100), stelle die Formeln zur Berechnung aller drei Größen dar und berechne: a) 15 % von 240 €, b) wie viel Prozent 18 Schüler von 30 Schülern sind, c) den Grundwert G, wenn 45 kg genau 30 % entsprechen.",
          "concept": "W = G * p/100; p% = (W / G) * 100%; G = W / (p/100); a) W = 240 * 0,15 = 36 €; b) p% = 18/30 = 0,60 = 60 %; c) G = 45 kg / 0,30 = 150 kg.",
          "sample_solution": "1. Grundgrößen und Berechnungsformeln: - Grundwert G: Das Ganze (100 %), auf das sich die Prozentangabe bezieht. Formel: G = W / (p / 100) = (W · 100) / p. - Prozentwert W: Der absolute Anteil des Ganzen (gleiche Einheit wie G). Formel: W = G · (p / 100) = (G · p) / 100. - Prozentsatz p%: Der relative Anteil in Hundertsteln. Formel: p% = W / G => p = (W · 100) / G. 2. Beispielberechnungen: - a) W = 240 € · 0,15 = 36 €. - b) p% = (18 / 30) = 0,60 = 60 %. - c) G = 45 kg / 0,30 = 150 kg."
        }
      ]
    },
    {
      "id": "01K4M7P0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4M7P0000000000000000A02",
      "namespace": "mathematik-anwendung",
      "slug": "vermehrter-verminderter-grundwert-prozentfaktor",
      "title": "Vermehrter und verminderter Grundwert: Prozentfaktor q und Rabattrechnung",
      "domain": "schule/mathematik/arithmetik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4M7P0000000000000000A01",
          "type": "hard",
          "rationale": "Grundbegriffe der Prozentrechnung sind Voraussetzung für vermehrte/verminderte Werte."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q11229",
          "target_label": "Discount and markup",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4M7P0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Mit welchem Änderungsfaktor (Prozentfaktor q) muss ein Grundwert direkt multipliziert werden, um einen um 20 % reduzierten Preis zu berechnen?",
          "concept": "q = 1 - 0,20 = 0,80 (entspricht 80 % des ursprünglichen Preises)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "q = 0,80 (1 - 0,20)",
              "q = 1,20 (1 + 0,20)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4M7P0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre das Rechnen mit dem Prozentfaktor q (vermehrt: q = 1 + p/100; vermindert: q = 1 - p/100) und löse folgende Praxisaufgabe: Ein Fahrrad kostet nach einem Rabatt von 15 % im Sommerschlussverkauf noch 595 €. Berechne den ursprünglichen Originalpreis vor der Rabattierung.",
          "concept": "Verminderter Grundwert G_minus = G * (1 - p/100) = G * 0,85 = 595 € <=> G = 595 € / 0,85 = 700 € (Achtung: Rabatt bezieht sich immer auf den Ausgangspreis 100 %).",
          "sample_solution": "1. Konzept des Prozentfaktors q: - Vermehrter Grundwert (z. B. Preiserhöhung, Mehrwertsteuer): G_+ = G · (1 + p/100) = G · q (mit q > 1). Bei +19 % MwSt. gilt: Bruttopreis = Nettopreis · 1,19. - Verminderter Grundwert (z. B. Rabatt, Skonto, Wertverlust): G_- = G · (1 - p/100) = G · q (mit q < 1). Bei 15 % Rabatt entspricht der Endpreis 100 % - 15 % = 85 % des Ursprungspreises (q = 0,85). 2. Berechnung des Originalpreises: - Gegeben: Verminderter Preis G_- = 595 €; Rabattsatz p% = 15 % => q = 1 - 0,15 = 0,85. - Ansatz: G · 0,85 = 595 €  |: 0,85. - Rechnung: G = 595 € / 0,85 = 700 €. - Antwort: Der ursprüngliche Originalpreis des Fahrrads betrug 700 €."
        }
      ]
    },
    {
      "id": "01K4M7P0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4M7P0000000000000000A03",
      "namespace": "mathematik-anwendung",
      "slug": "zinsrechnung-kapital-zinssatz-jahreszinsen",
      "title": "Einfache Zinsrechnung: Kapital K, Zinssatz p% und Jahreszinsen Z",
      "domain": "schule/mathematik/arithmetik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4M7P0000000000000000A01",
          "type": "hard",
          "rationale": "Zinsrechnung ist die Anwendung der Prozentrechnung auf Geld und Zeit."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q11229",
          "target_label": "Interest",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4M7P0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welchem Begriff aus der Prozentrechnung entspricht das angelegte Kapital K in der Zinsrechnung?",
          "concept": "Dem Grundwert G",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Dem Grundwert G (100 %)",
              "Dem Prozentwert W"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4M7P0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Stelle die Begriffe der Zinsrechnung denen der Prozentrechnung gegenüber (Kapital K <-> Grundwert G; Jahreszinsen Z <-> Prozentwert W; Zinssatz p% <-> Prozentsatz p%) und berechne das Guthaben nach einem Jahr, wenn ein Sparer ein Kapital von K = 4500 € zu einem Zinssatz von p% = 2,4 % fest für 1 Jahr anlegt.",
          "concept": "K <-> G, Z <-> W, p% <-> p%; Jahreszins Z = K * p/100 = 4500 € * 0,024 = 108 €; Endkapital K_neu = 4500 + 108 = 4608 € (bzw. 4500 * 1,024 = 4608 €).",
          "sample_solution": "1. Analogie Prozentrechnung vs. Zinsrechnung: - Kapital K entspricht dem Grundwert G (Geldsumme, 100 %). - Jahreszinsen Z entsprechen dem Prozentwert W (Vergütung für die Geldüberlassung in €). - Zinssatz p% entspricht dem Prozentsatz p% (Zinssatz pro Jahr, p.a.). 2. Jahreszinsformel: Z = K · (p / 100) = (K · p) / 100. 3. Berechnung: - Zinsen für 1 Jahr: Z = 4500 € · 0,024 = 108 €. - Neues Gesamtguthaben nach 1 Jahr: K_Ende = K + Z = 4500 € + 108 € = 4608 € (oder direkt: K · 1,024 = 4608 €)."
        }
      ]
    },
    {
      "id": "01K4M7P0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4M7P0000000000000000A04",
      "namespace": "mathematik-anwendung",
      "slug": "monatszinsen-tageszinsen-kaufmaennische-zeitrechnung",
      "title": "Unterjährige Zinsrechnung: Monats- und Tageszinsen nach kaufmännischer Methode",
      "domain": "schule/mathematik/arithmetik",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4M7P0000000000000000A03",
          "type": "hard",
          "rationale": "Jahreszinsen sind die Basis für zeitanteilige Zinsberechnungen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q11229",
          "target_label": "Day count convention",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Prozent- und Zinsrechnung",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4M7P0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie viele Tage hat nach der deutschen kaufmännischen Zinsmethode (30/360-Regel) jeder Monat und wie viele Tage hat das Bankjahr?",
          "concept": "Jeder Monat hat genau 30 Zinstage, das Bankjahr hat genau 360 Tage",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Jeder Monat 30 Tage, Bankjahr 360 Tage",
              "Monate nach Kalendertagen (28-31), Jahr 365 Tage"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4M7P0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Formuliere die Formeln für Monatszinsen (Z_m = K · p · m / (100 · 12)) und Tageszinsen (Z_t = K · p · t / (100 · 360)) und berechne die Überziehungszinsen (Dispozinsen), die eine Kundin zahlen muss, wenn ihr Girokonto 80 Tage lang um K = 1200 € bei einem Dispozinssatz von p% = 12 % überzogen war.",
          "concept": "Z_t = (K * p * t) / (100 * 360); Z_t = (1200 * 12 * 80) / (100 * 360) = 1.152.000 / 36.000 = 32 €.",
          "sample_solution": "1. Kaufmännische Zinsrechnung (Deutsche Zinsmethode 30/360): - Jeder Monat wird pauschal mit 30 Zinstagen gerechnet. - Das Bankjahr hat 12 · 30 = 360 Zinstage. 2. Formeln für unterjährige Zinsen: - Monatszinsen (für m Monate): Z_m = (K · p · m) / (100 · 12). - Tageszinsen (für t Tage): Z_t = (K · p · t) / (100 · 360). 3. Berechnung der Dispozinsen: - Gegeben: K = 1200 €; p = 12; t = 80 Tage. - Rechnung: Z_t = (1200 · 12 · 80) / (100 · 360) = 1.152.000 / 36.000 = 32 €. - Antwort: Die Kundin muss für die 80 Tage Kontoüberziehung genau 32,00 € Zinsen zahlen."
        }
      ]
    }
  ]
}
